"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeTimestamp = void 0;
/**
 * Relative timestamp, which can be decoded give a table
 * of clocks. Session index specifies clock indes in the table.
 */
class RelativeTimestamp {
    /**
     *
     * @param sessionIndex Index of the clock in clock table.
     * @param timeDiff Time difference relative to the clock time from the table.
     */
    constructor(sessionIndex, timeDiff) {
        this.sessionIndex = sessionIndex;
        this.timeDiff = timeDiff;
    }
}
exports.RelativeTimestamp = RelativeTimestamp;
